import React from 'react'

export default function RoomFeature({data}) {
  return (
    <>
     
    <section className="room-feature-section">
      <div className="container">
        <div className="row justify-content-end">

          <div className="col-lg-8">
            <h3 className="heading">6 good reasons for your holiday in De Coracao</h3>
            
            <div className="roomfeature-box">
              <ul>
                {data.features1.map((item, index) => (
                  <li key={index}>
                    <img src={item.icon} alt={item.alt || "room feature"} />
                    {item.text}
                  </li>
                ))}
              </ul>

              <ul>
                {data.features2.map((item, index) => (
                  <li key={index}>
                    <img src={item.icon} alt={item.alt || "room feature"} />
                    {item.text}
                  </li>
                ))}
              </ul>
            </div>
          </div>

        </div>
      </div>
    </section>
    </>
  )
}
